import { render, staticRenderFns } from "./IconGlobeAltSolid.vue?vue&type=template&id=53dcaabb"
import script from "./IconGlobeAltSolid.vue?vue&type=script&lang=js"
export * from "./IconGlobeAltSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports